import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Header from "../components/Header";
import Footer from "../components/Footer";
import MastodonLogoSvg from '../resources/images/mastodon-logo.svg';
import PixelfedLogoSvg from '../resources/images/pixelfed-logo.svg';

export default class About extends Component {

  constructor(props) {

    super(props);

    this.state = {}
  }

  render() {
    return (
      <div className="content">
        <Header />
        <div className="mt-4"/>
        <h1 className="text-center"><span className="logo-gradient">About Find my friends</span></h1>
        <div className="mt-4"/>
        <Container className="w-70">
        <div className="clearfix">
          <div>
          <img src={require('../resources/images/me.jpg')} alt="It's me" className="big-avatar rounded-circle col-md-6 float-md-end mb-3 ms-md-3" style={{ height: 240, width: 240 }}/>
          </div>
          <p className="fs-6">
          I'm <span className="bold">Álvaro</span>, a software developer and technology enthusiast who was looking forward to find an idea for building some tool which 
          helps people around the world.
          <br/><br/>
          <i>Find my friends</i> was born with a different idea from what it is today. But in the middle of the road, things went wrong and in order not to throw away the work, 
          I decided to pivot to what it is. 
          <br/>
          <i>Find my friends</i> has been my hobby for the last few months, every minute of free time I had, has been dedicated to this, simply just for fun and to collaborate with the community.
          I have little free time, I'm a father of a 1 year old toddler, I guess that gives you an idea.
          <br/><br/>
          I hope you enjoy using this tool and if you have any comments, suggestions or bugs to report I will be grateful to receive them. You can find me as nick  
          <span className="bold"> @kr0n</span> in the social networks.
          </p>
          <div className="mt-5"/>
          <div className="d-flex flex-wrap justify-content-center gap-6 mt-4">
            <a className="text-decoration-none animate-img" href="https://mas.to/@kr0n" target='_blank' rel="noreferrer">
              <img src={MastodonLogoSvg} style={{ height: 24, width: 24 }} alt="Pixelfed icon"/>
              <span className="text-muted fs-6"> kr0n@mas.to</span>
            </a>
            <a className="text-decoration-none animate-img" href="https://pixelfed.social/@kr0n" target='_blank' rel="noreferrer">
              <img src={PixelfedLogoSvg} style={{ height: 24, width: 24 }} alt="Pixelfed icon"/>
              <span className="text-muted fs-6"> kr0n@pixelfed.social</span>
            </a>
          </div>
          <div className="mt-5"/>
          <h4>Buy me a coffee</h4>
          <p className="fs-6">If you enjoyed <i>Find my friends</i> and it was useful for you, you can buy me a coffee or help me to pay the server bill.</p>
          <div className="d-flex flex-wrap justify-content-center gap-6 mt-4">
            <a href='https://ko-fi.com/X8X2JE03C' target='_blank' rel="noreferrer">
              <img height='36' style={{border: 0, height: 36}} src='https://storage.ko-fi.com/cdn/kofi2.png?v=3' border='0' alt='Buy Me a Coffee at ko-fi.com' />
            </a>
          </div>
          <div className="mt-5"/>
          <h4>Open Source?</h4>
          <p className="fs-6">That's the goal, but at the moment the code is not ready to share. I'll work on this the next months and I'll share here the link to the code repository.</p>
        </div>
        </Container>
        <div className="mt-5"/>
        <Footer />
      </div>

    );
  }
}
